import { Action } from '@ngrx/store'
import * as ContactTitlesTypes from './contact-titles.types'
import { ContactTitle } from './contact-titles.interface'

export class FetchContactTitlesRequest implements Action {
  readonly type = ContactTitlesTypes.FETCH_CONTACT_TITLES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchContactTitlesSuccess implements Action {
  readonly type = ContactTitlesTypes.FETCH_CONTACT_TITLES_SUCCESS
  constructor(
    public payload: ContactTitle[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchContactTitlesFailure implements Action {
  readonly type = ContactTitlesTypes.FETCH_CONTACT_TITLES_FAILURE
  constructor(public payload: any) {}
}

export class FetchContactTitleRequest implements Action {
  readonly type = ContactTitlesTypes.FETCH_CONTACT_TITLE_REQUEST
  constructor(public id: number) {}
}

export class FetchContactTitleSuccess implements Action {
  readonly type = ContactTitlesTypes.FETCH_CONTACT_TITLE_SUCCESS
  constructor(public payload: ContactTitle) {}
}

export class FetchContactTitleFailure implements Action {
  readonly type = ContactTitlesTypes.FETCH_CONTACT_TITLE_FAILURE
  constructor(public payload: any) {}
}

export class DeleteContactTitleRequest implements Action {
  readonly type = ContactTitlesTypes.DELETE_CONTACT_TITLE_REQUEST
  constructor(public id: number) {}
}

export class DeleteContactTitleSuccess implements Action {
  readonly type = ContactTitlesTypes.DELETE_CONTACT_TITLE_SUCCESS
  constructor() {}
}

export class DeleteContactTitleFailure implements Action {
  readonly type = ContactTitlesTypes.DELETE_CONTACT_TITLE_FAILURE
  constructor(public payload: any) {}
}

export class CreateContactTitleRequest implements Action {
  readonly type = ContactTitlesTypes.CREATE_CONTACT_TITLE_REQUEST
  constructor(public payload) {}
}

export class CreateContactTitleSuccess implements Action {
  readonly type = ContactTitlesTypes.CREATE_CONTACT_TITLE_SUCCESS
  constructor() {}
}

export class CreateContactTitleFailure implements Action {
  readonly type = ContactTitlesTypes.CREATE_CONTACT_TITLE_FAILURE
  constructor(public payload: any) {}
}

export class UpdateContactTitleRequest implements Action {
  readonly type = ContactTitlesTypes.UPDATE_CONTACT_TITLE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateContactTitleSuccess implements Action {
  readonly type = ContactTitlesTypes.UPDATE_CONTACT_TITLE_SUCCESS
  constructor() {}
}

export class UpdateContactTitleFailure implements Action {
  readonly type = ContactTitlesTypes.UPDATE_CONTACT_TITLE_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = ContactTitlesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = ContactTitlesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateContactTitleRequest
  | UpdateContactTitleSuccess
  | UpdateContactTitleFailure
  | FetchContactTitlesSuccess
  | FetchContactTitlesFailure
  | FetchContactTitlesRequest
  | FetchContactTitleSuccess
  | FetchContactTitleFailure
  | FetchContactTitleRequest
  | CreateContactTitleRequest
  | CreateContactTitleSuccess
  | CreateContactTitleFailure
  | DeleteContactTitleRequest
  | DeleteContactTitleSuccess
  | DeleteContactTitleFailure
  | SetDefaultData
  | UpdateField
  | FetchContactTitlesRequest
  | FetchContactTitlesSuccess
  | FetchContactTitlesFailure
